<template>
  <div id="app">
    <Navbar />
    <div class="mt-5" />
    <router-view />
    <Footer />
    <ScrollToTop />
 </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";
import ScrollToTop from "@/components/ScrollToTop.vue";

export default {
  name: "App",
  components: {
    Navbar,
    Footer,
    ScrollToTop,
  },
};
</script>

<style>
a {
  color: currentColor !important;
  text-decoration: none !important;
}

a:hover {
  text-decoration: underline !important;
}

p {
  font-size: 2rem;
}

h1 {
  font-weight: 700 !important;
}

body {
  font-family: "Montserrat", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif,
    "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  background-color: #212529;
  color: #fff;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}
</style>
